type Props = {
  value: string | null
  checked: boolean
  onCheckedChange: (b: boolean) => void
}

export function VerifyDialogClickSection({ value, checked, onCheckedChange }: Props) {
  return (
    <label className="flex items-start gap-2 rounded border border-slate-200 p-3">
      <input
        type="checkbox"
        checked={checked}
        onChange={e => onCheckedChange(e.target.checked)}
        className="mt-0.5"
      />
      <span className="text-sm text-slate-700">
        Potwierdzam, że wartość{' '}
        <strong className="font-semibold">{value ?? '—'}</strong>{' '}
        jest poprawna.
      </span>
    </label>
  )
}
